const navLinks = [
  { label: 'ホーム', href: '#home' },
  { label: 'サロンについて', href: '#about' },
  { label: '施術メニュー', href: '#services' },
  { label: 'お客様の声', href: '#reviews' },
  { label: 'ご予約・お問い合わせ', href: '#booking' },
];

const menuItems = [
  { label: 'ヘッドスパ・ドライヘッドマッサージ', price: '¥7,700〜' },
  { label: 'フェイシャル・小顔矯正', price: '¥8,800〜' },
  { label: 'よもぎ蒸し', price: '¥5,500〜' },
  { label: 'リンパマッサージ', price: '¥8,800〜' },
];

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="access" className="bg-[#3a3530] text-white">
      <div className="max-w-6xl mx-auto px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-1">
            <p
              className="text-2xl font-light tracking-[0.2em] mb-2"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Relax Moonseed
            </p>
            <p
              className="text-white/50 text-xs tracking-widest mb-5"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              リラクゼーションサロン
            </p>
            <p
              className="text-white/50 text-xs leading-7"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              兵庫県尼崎市<br />
              完全個室プライベートサロン<br />
              完全予約制
            </p>
          </div>

          {/* Nav */}
          <div>
            <p
              className="text-white/40 text-xs tracking-[0.3em] mb-5 uppercase"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Navigation
            </p>
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-white/60 hover:text-white text-xs tracking-wide transition-colors duration-200 cursor-pointer"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Menu */}
          <div>
            <p
              className="text-white/40 text-xs tracking-[0.3em] mb-5 uppercase"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Menu
            </p>
            <div className="flex flex-col gap-3">
              {menuItems.map((item) => (
                <div key={item.label} className="flex items-center justify-between gap-3">
                  <span
                    className="text-white/60 text-xs tracking-wide"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {item.label}
                  </span>
                  <span
                    className="text-white/40 text-xs whitespace-nowrap"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {item.price}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Access & SNS */}
          <div>
            <p
              className="text-white/40 text-xs tracking-[0.3em] mb-5 uppercase"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Access &amp; SNS
            </p>
            <div className="flex flex-col gap-3 mb-7">
              <div className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-white/40 text-sm" />
                </div>
                <p
                  className="text-white/60 text-xs leading-6"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  兵庫県尼崎市<br />
                  （詳細はDMにてお知らせします）
                </p>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-white/40 text-sm" />
                </div>
                <p
                  className="text-white/60 text-xs"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  完全予約制・当日予約可
                </p>
              </div>
            </div>

            <p
              className="text-white/40 text-xs tracking-[0.3em] mb-4 uppercase"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Follow Us
            </p>
            <a
              href="https://www.instagram.com/relax_moonseed/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-instagram-line text-base" />
              </div>
              <span
                className="text-xs"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                @relax_moonseed
              </span>
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-3">
          <p
            className="text-white/30 text-xs tracking-widest"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            © 2024 Relax Moonseed. All rights reserved.
          </p>
          <p
            className="text-white/20 text-xs"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            兵庫県尼崎市 完全個室リラクゼーションサロン
          </p>
        </div>
      </div>

      {/* Large brand watermark */}
      <div className="overflow-hidden py-4">
        <p
          className="text-center text-[#4a4540] font-light select-none whitespace-nowrap"
          style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '6rem', letterSpacing: '0.15em' }}
        >
          Moonseed
        </p>
      </div>
    </footer>
  );
}
